module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/dinner-course-photo-3-2-25f74f9ec95b2efc55bc2befa32f6d23.jpg";